'use client';

import { c as _c } from "react/compiler-runtime";
import BlurTooltip from '@components/blur-tooltip/BlurTooltip';
import tagMob from '@images/renders/visual_images/tagMob.svg';
import { setBottomSheetIsOpen, sheetIsOpenSelector } from '@lib/store/slices/VisualFloorSlice';
import cn from 'classnames';
import { useParams } from 'next/navigation';
import { useCallback, useEffect, useMemo, useState } from 'react';
import SVG from 'react-inlinesvg';
import { useDispatch, useSelector } from 'react-redux';
import BackLink from '../visual-bottom-links/BackLink/BackLink';
import style from './BottomSheet.module.scss';
const getSheetOnFloorStyle = (isOpen, activeForm) => {
  if (!isOpen) return style.sheetForFloor;
  if (activeForm) return style.openSheet;
  return style.openSheetForm;
};
const useSheetStyles = (isOpen, props, floorId, reserved) => {
  const $ = _c(3);
  let t0;
  bb0: {
    if (floorId) {
      if (reserved) {
        t0 = isOpen ? style.flatSheetOpen_reserved : style.sheetForFlat_reserved;
        break bb0;
      }
      t0 = isOpen ? style.flatSheetOpen : style.sheetForFlat;
      break bb0;
    }
    if (props.houseId) {
      let t1;
      if ($[0] !== isOpen || $[1] !== props.activeForm) {
        t1 = getSheetOnFloorStyle(isOpen, props.activeForm);
        $[0] = isOpen;
        $[1] = props.activeForm;
        $[2] = t1;
      } else {
        t1 = $[2];
      }
      t0 = t1;
      break bb0;
    }
    t0 = isOpen ? style.openSheet : style.sheetForRoot;
  }
  return t0;
};
const BottomSheet = props => {
  const $ = _c(24);
  const {
    isReservedFlat
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [startY, setStartY] = useState(null);
  const {
    floorId,
    houseId,
    bulkId
  } = useParams();
  const dispatch = useDispatch();
  const sheetIsOpen = useSelector(sheetIsOpenSelector);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = e => {
      setStartY(e.touches[0].clientY);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleTouchStart = t0;
  let t1;
  if ($[1] !== dispatch || $[2] !== startY) {
    t1 = e_0 => {
      const currentY = e_0.touches[0].clientY;
      const deltaY = currentY - startY;
      const newIsOpen = deltaY < 0;
      setIsOpen(newIsOpen);
      dispatch(setBottomSheetIsOpen(newIsOpen));
    };
    $[1] = dispatch;
    $[2] = startY;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleTouchMove = t1;
  const sheetStyle = useSheetStyles(isOpen, props, floorId, isReservedFlat);
  let t2;
  let t3;
  if ($[4] !== sheetIsOpen) {
    t2 = () => {
      if (sheetIsOpen) {
        setIsOpen(true);
      }
    };
    t3 = [sheetIsOpen];
    $[4] = sheetIsOpen;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  const bottomSheetClass = isReservedFlat ? style.reservedFlatSheet : "";
  const t4 = floorId ? style.flatWrapper : style.wrapper;
  let t5;
  if ($[7] !== bottomSheetClass || $[8] !== sheetStyle || $[9] !== t4) {
    t5 = cn(t4, sheetStyle, bottomSheetClass);
    $[7] = bottomSheetClass;
    $[8] = sheetStyle;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <BackLink />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== bulkId || $[13] !== houseId || $[14] !== props.isMobile) {
    t7 = props.isMobile && (!houseId || houseId && !bulkId) && <BlurTooltip someStyles={style.tagMob}><SVG src={tagMob.src} /></BlurTooltip>;
    $[12] = bulkId;
    $[13] = houseId;
    $[14] = props.isMobile;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className={style.toggler} />;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== props.children) {
    t9 = <div className={style.children}>{t8}{props.children}</div>;
    $[17] = props.children;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== handleTouchMove || $[20] !== t5 || $[21] !== t7 || $[22] !== t9) {
    t10 = <div onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} className={t5}>{t6}{t7}{t9}</div>;
    $[19] = handleTouchMove;
    $[20] = t5;
    $[21] = t7;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
};
export default BottomSheet;